import * as Sentry from "@sentry/react";

/**
 * Doesn't rely on crypto module at all, assured to work in all browsers.
 * Not cryptographically secure, not recommended for security-sensitive use cases.
 * Higher collision risk than randomUniqueId() but collisions unlikely at our volumes.
 */
export function randomId(length?: number) {
  // Unable to use crypto.randomUUID(); without polly-fill due to some devices on old chrome versions
  // Generate two random values and concatenate for better entropy and collision resistance
  const generateSegment = () => {
    let segment = "";
    // Retry until we get a non-zero Math.random() value (probability of zero is ~1 in 2^53)
    while (!segment) {
      segment = Math.random().toString(36).slice(2);
    }
    return segment;
  };

  const id = `${generateSegment()}-${generateSegment()}`;
  if (length) {
    return id.slice(0, length);
  }
  return id;
}

/**
 * Small chance of clients running older browsers without crypto.getRandomValues()
 * Cryptographically secure
 * Collision risk infintessimally low at our volumes
 */
export function randomUniqueId(length?: number) {
  try {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    const id = [...bytes].map((b) => b.toString(36)).join("");
    if (length) {
      return id.slice(0, length);
    }
    return id;
  } catch (error) {
    Sentry.captureException(error);
    return randomId(length);
  }
}
